module.exports = __webpack_public_path__ + "img/huc-hover.c3f5239e.png";